import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { IUser, UserFormData } from "../../../../utils/api/user/user.type";
import { useNavigate } from "react-router-dom";
import { cleannerError, useUser, validatePhone } from "../../../../utils/Utils";
import { Color } from "../../../../utils/theme";
import { onSetUser } from "../../../../redux/slice/User.slice";
import { Data } from "../../../common/GoogleInput";
import { useAddOrEditAdminMutation, useDeleteUserMutation } from "../../../../utils/api/user/user.api";
import { useAppDispatch } from "../../../../redux/hook";
import { Authorisations } from "../../../../utils/constante";

function useCrudAdminForm(item?: IUser) {
  const [code, setCode] = useState<string>("");
  const [phone, setPhone] = useState<string>();
  const validationSchema = yup.object().shape({
    nom: yup.string().required().label("Le nom"),
    prenom: yup.string().required().label("Le prénom"),
    telephone: validatePhone(yup, code).required(),
    email: yup.string().email().required().label("L'email"),
    adresse: yup.string().label("L'adresse").nullable(),
  });
  const navigate = useNavigate();
  const user = useUser();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    clearErrors,
    control,
  } = useForm<UserFormData>({
    resolver: yupResolver(validationSchema),
  });
  const dispatch = useAppDispatch();
  const [addOrUpdateUser, { isLoading, isSuccess, error, isError, data }] =
    useAddOrEditAdminMutation();
  const [avatar, setAvatar] = useState(null);
  const [address, setAddress] = useState("");

  const handleChangeAvatar = (e) => {
    let files = e.target.files[0];
    setValue("avatar", files);
    setAvatar(files);
  };

  const onChangeAddress = (val: Data) => {
    setAddress(val?.rue);
    setValue(`adresse`, val?.rue);
    setValue(`latitude`, parseFloat(val?.latitude).toFixed(6));
    setValue(`longitude`, parseFloat(val?.longitude).toFixed(6));
  };

  const handleChangePhone = (item: any, country: any) => {
    setPhone(item);
    setCode(country?.countryCode);
    if (parseInt(item) !== parseInt(country?.dialCode)) {
      setValue("telephone", item);
    } else {
      setValue("telephone", "");
    }
  };

  useEffect(() => {
    if (isSuccess) {
      if (data?.id) {
        if (user?.id === data?.id) {
          dispatch(onSetUser(data));
        }
      }

      Swal.fire({
        icon: "success",
        title: !item
          ? "L'administrateur a été ajouté avec succès"
          : "Les informations ont été modifiées avec succès",
        iconColor: Color.success,
        showConfirmButton: false,
        timer: 2000,
      }).then(() => {
        navigate("/admin/parametres", { state: "administrateurs" });
      });
    }
    const err = error as any;
    if (isError) {
      if (err?.data?.email?.includes("user with this email already exists.")) {
        Swal.fire({
          icon: "error",
          title: "Un utilisateur avec cet email exite déjà!",
          showConfirmButton: false,
          timer: 2000,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: err?.data?.message
            ? err?.data?.message
            : `Erreur de statut ${err?.status}`,
          showConfirmButton: false,
          timer: 5000,
        });
      }
    }
  }, [isLoading]);

  useEffect(() => {
    if (!item) {
      for (let field of Authorisations) {
        register(field?.field);
        setValue(field?.field, true);
      }
    }
  }, [item]);

  useEffect(() => {
    cleannerError(errors, clearErrors);
  }, [errors]);

  useEffect(() => {
    if (item?.id) {
      
      let fields: (keyof UserFormData)[] = [
        "nom",
        "prenom",
        "telephone",
        "email",
        "adresse",
        "dashboard",
        "admin_habilitation",
        "rdv_habilitation",
        "hopitaux_habilitation",
        "praticien_habilitation",
        "specialite_habilitation",
      ];

      if (user?.telephone) {
        setPhone(item.telephone);
      }

      if (item?.adresse) {
        setAddress(item.adresse);
      }

      for (let field of fields) {
        register(field);
        setValue(field, item[field]);
      }
    }
  }, [item]);

  const onSubmit = async (data: UserFormData) => {
    // if (!item) data["user_type"] = "admin";
    
    const fd = new FormData();

    for (let key of Object.keys(data)) {
      if (key === "avatar") {
        if (data?.avatar) {
          fd.append(key, data?.avatar);
        }
      } else if (key === "date_de_naissance") {
        if (data?.date_de_naissance) {
          fd.append(key, data?.date_de_naissance);
        }
      } else {
        fd.append(key, data[key]);
      }
    }
    await addOrUpdateUser({
      slug: item?.slug,
      data: fd,
    });
  };

  return {
    register,
    errors: errors,
    onSubmit: handleSubmit(onSubmit),
    setValue,
    isLoading,
    handleChangeAvatar,
    handleChangePhone,
    onChangeAddress,
    Controller,
    control,
    phone,
    address,
    avatar,
    isSuccess,
  };
}

export default useCrudAdminForm;

export function UseArchiveAdmin(item: IUser) {
  const [sendData] = useAddOrEditAdminMutation();
  const onArchive = async () => {
    await Swal.fire({
      title: `Êtes-vous sûr de vouloir ${
        item?.is_archive ? "désarchiver" : "archiver"
      } cet administrateur ?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "OUI",
      cancelButtonText: "NON",
      showLoaderOnConfirm: true,
      iconColor: Color.themeColor,
      confirmButtonColor: Color.themeColor,
      preConfirm: () => {
        return sendData({
          slug: item?.slug,
          data: { is_archive: !item?.is_archive, is_active: item?.is_archive },
        });
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result: any) => {
      if (result?.isConfirmed) {
        if (result?.value && !result?.value?.error) {
          Swal.fire({
            icon: "success",
            title: `L'administrateur a été ${
              item?.is_archive ? "désarchivé" : "archivé"
            } avec succès!`,
            iconColor: Color.themeColor,
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          let err = result?.value?.error;
          Swal.fire({
            icon: "error",
            title: err?.data?.message
              ? err?.data?.message
              : `Une erreur de statut ${err?.status} est survenue!`,
            showConfirmButton: false,
            timer: 5000,
          });
        }
      }
    });
  };
  return onArchive;
}

export function UseDeleteAdmin(slug: string, redirectRoute?: string) {
  const [sendData] = useDeleteUserMutation();
  const navigate = useNavigate();
  const onDelete = async () => {
    await Swal.fire({
      title: `Êtes-vous sûr de vouloir supprimer cet administrateur ?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "OUI",
      cancelButtonText: "NON",
      showLoaderOnConfirm: true,
      iconColor: Color.themeColor,
      confirmButtonColor: Color.themeColor,
      preConfirm: () => {
        return sendData(slug);
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result: any) => {
      if (result?.isConfirmed) {
        if (result?.value && !result?.value?.error) {
          Swal.fire({
            icon: "success",
            title: `L'administrateur a été supprimé avec succès!`,
            iconColor: Color.themeColor,
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            if (redirectRoute) {
              navigate(redirectRoute);
            }
          });
        } else {
          let err = result?.value?.error;
          Swal.fire({
            icon: "error",
            title: err?.data?.message
              ? err?.data?.message
              : `Une erreur de statut ${err?.status} est survenue!`,
            showConfirmButton: false,
            timer: 5000,
          });
        }
      }
    });
  };
  return onDelete;
}